import textAboveSVG from '../assets/icons/textAbove.svg';
import textBelowSVG from '../assets/icons/textBelow.svg';
import textInsideSVG from '../assets/icons/textInside.svg';
import textLeftSVG from '../assets/icons/textLeft.svg';
import textLocationSVG from '../assets/icons/textLocation.svg';
import textRightSVG from '../assets/icons/textRight.svg';
import { camelToSentenceCase } from '../utils/string';
import GenericListTool from './GenericListTool';

const textPositionChoices = [
  { value: 'left', iconSVG: textLeftSVG },
  { value: 'right', iconSVG: textRightSVG },
  { value: 'above', iconSVG: textAboveSVG },
  { value: 'below', iconSVG: textBelowSVG },
  { value: 'inside', iconSVG: textInsideSVG },
].map(choice => {
  return {
    ...choice,
    toolName: camelToSentenceCase(choice.value),
  };
});

const makeToolTextLocation = (choices = textPositionChoices) =>
  GenericListTool({
    toolName: 'Text location',
    attribute: 'textLocation',
    iconSVG: textLocationSVG,
    choices,
  });

export const ToolTextLocation = makeToolTextLocation();
export const ToolTextLocationOutside = makeToolTextLocation(
  textPositionChoices.filter(choice => choice.value !== 'inside')
);
